/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { http, HttpResponse } from 'msw';
import metagochi from './mockMetagotchiPlugin';
import { mockPluginCatalog } from './mockPluginCatalog';
import timeslider from './mockTimesliderPlugin';

export const pluginEndpoints = [
  http.get(/.*plugins\/metadata.*/, async () => {
    return HttpResponse.json(mockPluginCatalog);
  }),
  http.get(/.*plugins\/.+\/metagotchi\/.+\/bundle/, async () => {
    return new HttpResponse(metagochi, {
      headers: { 'Content-Type': 'application/javascript' },
    });
  }),
  http.get(/.*plugins\/.+\/bundle/, async () => {
    return new HttpResponse(timeslider, {
      headers: { 'Content-Type': 'application/javascript' },
    });
  }),
];
